module.exports = __webpack_public_path__ + "img/i02.dd1aa71e.svg";